import { trpc } from "../../../main/trpc.ts";

const usePreferences = () => {
  const { data: prefs } = trpc.preference.get.useQuery();
  return prefs || null;
};

export { usePreferences };
